// @flow
import { makeGetRequest } from '../utils'

import type { ResponseAPI } from '../types/api'
import type { Category } from '../types/categories'

export const getRadioChannelCategories = (domain: string, serviceId: string): Promise<ResponseAPI<Category>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceId}/radio/categories`)
